import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { Sticky, StickyContainer } from 'react-sticky';

import { CONSTANTS } from '../../../../../../core/config/constants';
import CompanyTabs from '../../../../../FinancialData/Company/CompanyTabs';
import HeaderPanel from '../../../../../FinancialData/Company/HeaderPanel';
import { useBenchmarkState } from '../../../../Context/BenchmarkContext';
import ResolutionPanel from './ResolutionPanel';
import ResolutionPanelCM from './ResolutionPanelCM';

const CompanyBlock: React.FC = () => {
  const { activeBenchmark } = useBenchmarkState();
  const isBenchwiseStudy = !!activeBenchmark?.benchwiseStudy;
  const classes = useStyles();
  return (
    <StickyContainer className={classes.companyBlock}>
      <HeaderPanel />
      <Sticky topOffset={CONSTANTS.SCROLL_TOP_OFFSET}>
        {({ style }) => (
          <Box style={style}>
            {isBenchwiseStudy ? <ResolutionPanelCM /> : <ResolutionPanel />}

            <CompanyTabs
              tabsOffset={150}
              consolidationPreference={activeBenchmark?.consolidationPreference}
            />
          </Box>
        )}
      </Sticky>
    </StickyContainer>
  );
};

const useStyles = makeStyles((theme) => ({
  companyBlock: {
    width: 'calc(100% - 360px)',
    paddingRight: theme.spacing(4),
    //     userSelect: 'none',
  },
}));

export default CompanyBlock;
